var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _c(
        "div",
        { staticClass: "content search-content" },
        [
          _c("search-com", {
            attrs: { type: "1" },
            on: { outputSearchData: _vm.receiveSearchData },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "content" }, [
        _c("h3", { staticClass: "card-title" }, [_vm._v("基础数据")]),
        _c(
          "div",
          { staticClass: "base-data-list" },
          [
            _vm._l(_vm.baseDataList, function (item, index) {
              return [
                _c("basic-data", {
                  attrs: { basicDataItem: item, basicDataItemIndex: index },
                }),
              ]
            }),
          ],
          2
        ),
      ]),
      _c("div", { staticClass: "content sale-chart" }, [
        _c("div", { staticClass: "sale-chart-left" }, [
          _vm._m(0),
          _vm._m(1),
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("total-sales", {
                attrs: {
                  config: _vm.trend.config,
                  dataList: _vm.trend.dataList,
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "sale-chart-right" },
          [
            _vm._m(2),
            _c("distribution", {
              attrs: {
                config: _vm.orderAmount.config,
                dataList: _vm.orderAmount.dataList,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", { staticClass: "card-title" }, [
            _c("label", [_vm._v("员工排行榜")]),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _vm._l(_vm.staffButtonList, function (item) {
                  return _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type:
                          _vm.currentChooseStaff == item.value
                            ? "primary"
                            : "info",
                        plain: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onChangeStaffType(item.value)
                        },
                      },
                    },
                    [_vm._v(_vm._s(item.name) + " ")]
                  )
                }),
                _c("el-button", {
                  staticClass: "download-table",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onDownloadStaff()
                    },
                  },
                }),
              ],
              2
            ),
          ]),
          _c("data-board-table", {
            attrs: {
              dataList: _vm.page.list,
              config: _vm.staffTableConfigs.list,
              sortObj: _vm.staffTableConfigs.sortObj,
            },
          }),
          _vm.page.totalNum >= 8
            ? _c(
                "div",
                { staticClass: "page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.page.pageNo,
                      "page-sizes": [3, 5, 10, 20, 50],
                      "page-size": _vm.page.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.page.totalNum,
                      "prev-text": "上一页",
                      "next-text": "下一页",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("h3", { staticClass: "card-title" }, [
            _c("label", [_vm._v("近一年员工业绩")]),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("el-button", {
                  staticClass: "download-table",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onDownloadStaff()
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c("data-board-table", {
            attrs: {
              dataList: _vm.page.list,
              config: _vm.staffTableAchievement.list,
              sortObj: _vm.staffTableAchievement.sortObj,
            },
            on: { tableShowDetail: _vm.showDetail },
          }),
          _vm.page.totalNum >= 8
            ? _c(
                "div",
                { staticClass: "page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      background: "",
                      "current-page": _vm.page.pageNo,
                      "page-sizes": [3, 5, 10, 20, 50],
                      "page-size": _vm.page.pageSize,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.page.totalNum,
                      "prev-text": "上一页",
                      "next-text": "下一页",
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.dialog.title,
            visible: _vm.dialog.visible,
            width: _vm.dialog.width,
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.dialog, "visible", $event)
            },
          },
        },
        [
          _vm.dialog.type === "performanceStatistics"
            ? [
                _c(
                  "el-button",
                  {
                    staticClass: "performanceStatistics-download",
                    attrs: { size: "small", type: "primary", plain: "" },
                    on: { click: _vm.performanceStatisticsDownload },
                  },
                  [_vm._v("下载")]
                ),
                _c("data-board-table", {
                  attrs: {
                    dataList: _vm.page.list,
                    config: _vm.staffTableConfigs.list,
                    sortObj: _vm.staffTableConfigs.sortObj,
                  },
                }),
                _vm.page.totalNum >= 8
                  ? _c(
                      "div",
                      { staticClass: "page" },
                      [
                        _c("el-pagination", {
                          attrs: {
                            background: "",
                            "current-page": _vm.page.pageNo,
                            "page-sizes": [3, 5, 10, 20, 50],
                            "page-size": _vm.page.pageSize,
                            layout: "total, sizes, prev, pager, next, jumper",
                            total: _vm.page.totalNum,
                            "prev-text": "上一页",
                            "next-text": "下一页",
                          },
                          on: {
                            "size-change": _vm.handleSizeChange,
                            "current-change": _vm.handleCurrentChange,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "card-title" }, [
      _c("label", [_vm._v("销售总额7天变化趋势")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "card-total" }, [
        _c("div", { staticClass: "card-total-left" }, [
          _c("span", [_vm._v("￥")]),
          _c("label", [_vm._v("23,456.00")]),
        ]),
        _c("div", { staticClass: "card-total-right" }, [
          _c("label", [_vm._v("合计")]),
          _c("span", [_vm._v("￥")]),
          _c("label", [_vm._v("13,456.00")]),
        ]),
      ]),
      _c("div", { staticClass: "card-ratio" }, [
        _c("div", { staticClass: "card-ratio-left" }, [
          _c("p", { staticClass: "data-green" }, [
            _c("span", { staticClass: "arrow south-east" }, [_vm._v("↘")]),
            _c("span", { staticClass: "arrow north-east" }, [_vm._v("↗")]),
            _c("label", [_vm._v("环比增长")]),
            _vm._v("+25% "),
          ]),
        ]),
        _c("div", { staticClass: "card-ratio-right" }, [
          _c("label", [_vm._v("均值")]),
          _c("span", [_vm._v("￥")]),
          _c("label", [_vm._v("43,410.00")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h3", { staticClass: "card-title" }, [
      _c("label", [_vm._v("下单金额分布占比")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }